export const checkCreditSourceBookRowCommonParams = (props) => checkRowParam({
    ...props,
    fieldKey: 'isSalaryClient',
    viewSettingFieldKey: 'isShowSalaryClient',
}) &&
    checkRowParam({
        ...props,
        fieldKey: 'isStateEmployee',
        viewSettingFieldKey: 'isShowStateEmployee',
    }) &&
    checkRowParam({
        ...props,
        fieldKey: 'isPensionClient',
        viewSettingFieldKey: 'isShowPensionClient',
    }) &&
    checkRowParam({
        ...props,
        fieldKey: 'isInsurance',
        viewSettingFieldKey: 'isShowInsurance',
    });
const checkRowParam = ({ row, userInputParams, paramsViewSettings, fieldKey, viewSettingFieldKey, }) => {
    const isExclude = paramsViewSettings ? !paramsViewSettings[viewSettingFieldKey] : false;
    return isExclude || userInputParams[fieldKey] === row[fieldKey];
};
//# sourceMappingURL=checkCreditSourceBookRowCommonParams.js.map